import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";

// Notification System is provided once, at the app root (see App.js) —
// this layout renders inside that provider, so it doesn't need its own.

function UserLayout() {
  return (
    <>
      <Navbar />

      <div className="main-content">
        <Outlet />
      </div>

      <Footer />
    </>
  );
}

export default UserLayout;  